import { embedDashboard } from '@superset-ui/embedded-sdk';
import React, { useEffect, useLayoutEffect, useState, useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { Container } from 'reactstrap';
import config from '../../config.json';
import entityComposition from '../common/classes/entityComposition';
import useWindowDimensions from '../../utils/useWindowDimensions';
const Superset = ({
  superset: _superset = null,
  dashboardTitle: _dashboardTitle = null
}) => {
  const {
    height
  } = useWindowDimensions();
  const [selected, setSelected] = useState(null);
  const {
    token,
    dashboards = []
  } = _superset || {};
  useEffect(() => {
    if (!dashboards.length) {
      return;
    }
    const filtered = dashboards.filter(dash => dash.name === _dashboardTitle);
    if (filtered.length) {
      setSelected(filtered[0].embedID);
    }
  }, [_dashboardTitle, dashboards]);
  const resizeIframe = useCallback(() => {
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.style.minHeight = `${height - 92 - 15 - 15}px`;
      iframe.style.width = '100%'; // Set the width of the iframe
    }
  }, [height]);
  /**
   * Use layout to ensure the div is rendered
   * before trying to embed the dashboard.
   */
  useLayoutEffect(() => {
    if (!selected || !token) {
      return;
    }
    embedDashboard({
      id: selected,
      supersetDomain: config.supersetURL,
      mountPoint: document.getElementById('superset-container'),
      fetchGuestToken: () => token,
      dashboardUiConfig: {
        hideTitle: true,
        hideChartControls: false,
        hideTab: true
      }
    });
    resizeIframe();
    // We don't want to regenerate the dashboard every time the window size
    // changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, _dashboardTitle, token]);
  useEffect(() => {
    resizeIframe();
  }, [resizeIframe]);
  if (_dashboardTitle === null) {
    return 'No dashboards found, please contact your administrator.';
  }
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React.createElement("div", {
    id: "superset-container",
    "data-testid": "superset-container"
  }));
};
export { Superset as TestSuperset };
Superset.propTypes = {
  superset: PropTypes.shape({
    token: PropTypes.string,
    dashboards: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  dashboardTitle: PropTypes.string
};
export default entityComposition(Superset, [], {
  superset: state => {
    var _state$login;
    return state === null || state === void 0 || (_state$login = state.login) === null || _state$login === void 0 || (_state$login = _state$login.user) === null || _state$login === void 0 ? void 0 : _state$login.superset;
  }
});